import "jquery-validation";
import "jquery-ui-dist/jquery-ui.js";
import "foundation-sites";
import "slick-carousel";
import "jquery-mousewheel";
import "jquery.browser";
import "malihu-custom-scrollbar-plugin";
import "jquery-touchswipe";
import "jquery.inputmask";

export function formatCurrency() {
  return '&nbsp;&#8381;';
}

export function formatPrice(price) {
  return formatPriceNumber(price) + formatCurrency();
}

export function formatPriceNumber(price) {
  price = Math.round(price);
  var parts = price.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

export function initNavbar() {
  $(document).on('click', '#navbar-toggle', function () {
    var panel_left = $('#left-side');
    var btn = $(this);

    var is_show_panel = $(this).attr('class').indexOf('collapsed');

    if (is_show_panel == -1) {
      panel_left.hide(
        'fast',
        function () {
          btn.addClass('collapsed');
          panel_left.removeClass('active');
        });
    } else {
      panel_left.show(
        'fast',
        function () {
          btn.removeClass('collapsed');
          panel_left.addClass('active');
        });
    }
  });
}

(function ($) {
  "use strict";
  window.$ = window.jQuery = $;

  window.htmlspecialcharsDecode = function (string, quoteStyle) {
    // eslint-disable-line camelcase
    //       discuss at: https://locutus.io/php/htmlspecialchars_decode/
    //      original by: Mirek Slugen
    //      improved by: Kevin van Zonneveld (https://kvz.io)
    //      bugfixed by: Mateusz "loonquawl" Zalega
    //      bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    //      bugfixed by: Brett Zamir (https://brett-zamir.me)
    //      bugfixed by: Brett Zamir (https://brett-zamir.me)
    //         input by: ReverseSyntax
    //         input by: Slawomir Kaniecki
    //         input by: Scott Cariss
    //         input by: Francois
    //         input by: Ratheous
    //         input by: Mailfaker (https://www.weedem.fr/)
    //       revised by: Kevin van Zonneveld (https://kvz.io)
    // reimplemented by: Brett Zamir (https://brett-zamir.me)
    //        example 1: htmlspecialchars_decode("<p>this -&gt; &quot;</p>", 'ENT_NOQUOTES')
    //        returns 1: '<p>this -> &quot;</p>'
    //        example 2: htmlspecialchars_decode("&amp;quot;")
    //        returns 2: '&quot;'
    let optTemp = 0
    let i = 0
    let noquotes = false
    if (typeof quoteStyle === 'undefined') {
      quoteStyle = 2
    }
    string = string.toString()
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
    const OPTS = {
      ENT_NOQUOTES: 0,
      ENT_HTML_QUOTE_SINGLE: 1,
      ENT_HTML_QUOTE_DOUBLE: 2,
      ENT_COMPAT: 2,
      ENT_QUOTES: 3,
      ENT_IGNORE: 4
    }
    if (quoteStyle === 0) {
      noquotes = true
    }
    if (typeof quoteStyle !== 'number') {
      // Allow for a single string or an array of string flags
      quoteStyle = [].concat(quoteStyle)
      for (i = 0; i < quoteStyle.length; i++) {
        // Resolve string input to bitwise e.g. 'PATHINFO_EXTENSION' becomes 4
        if (OPTS[quoteStyle[i]] === 0) {
          noquotes = true
        } else if (OPTS[quoteStyle[i]]) {
          optTemp = optTemp | OPTS[quoteStyle[i]]
        }
      }
      quoteStyle = optTemp
    }
    if (quoteStyle & OPTS.ENT_HTML_QUOTE_SINGLE) {
      // PHP doesn't currently escape if more than one 0, but it should:
      string = string.replace(/&#0*39;/g, "'")
      // This would also be useful here, but not a part of PHP:
      // string = string.replace(/&apos;|&#x0*27;/g, "'");
    }
    if (!noquotes) {
      string = string.replace(/&quot;/g, '"')
    }
    // Put this in last place to avoid escape being double-decoded
    string = string.replace(/&amp;/g, '&')
    return string
  }

  window.openPopupCard = function () {

    if (($('.containerCards .imgContSlider').length) <= 5) {

      $('.rightControl').css('display', 'none');
      $('.leftControl').css('display', 'none');

    } else {
      $('.containerCards').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        arrows: true,
        nextArrow: $('.rightControl'),
        prevArrow: $('.leftControl'),
        adaptiveHeight: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });
    }


    $('.modalCardCont').css('display', 'block').removeClass('closeClass');
    $('body').css({'overflow': 'hidden', 'position': 'sticky'});
    //  $('.page-header').css('z-index', '6');
    $('.page-header, .modalCard').addClass('modal-open');
    $('.menu-user').addClass('menu_fixed');
  }


  window.reloadBasket = function reloadBasket(hidePrice, updateCalendar, updatePopupBasket, datePopup) {
    if (hidePrice === undefined) {
      hidePrice = false;
    }
    if (updateCalendar === undefined) {
      updateCalendar = true;
    }
    let wordCalOpen = $(document).find(".word__cal").hasClass('js-opened');

    $.ajax({
      method: 'GET',
      url: '/ajax/miniBasket.php',
      data: {'hide_price': hidePrice},
      cache: false,
      contentType: 'json',
      dataType: 'html',
      success: function (data) {
        if (data) {
          let $data = $(data);
          $(document).find('[data-entity="basket-main-wrapper"]').html($data.siblings('[data-ajax-container="main"]').children());
          $(document).find('[data-entity="basket-mobile-wrapper"]').html($data.siblings('[data-ajax-container="mobile"]').children());

          let basketpopup = $(document).find('[data-ajax-container="popup-basket"]');
          basketpopup.find('.word').html($data.siblings('[data-ajax-container="popupcart"]').find('.word').html());
          basketpopup.find('.button__buylink').remove();
          basketpopup.append($data.siblings('[data-ajax-container="popupcart"]').find('.button__buylink'));

          if ($(document).find('[data-entity="popup-basket-day-wrapper"]').length === 0) {
            $(document).find('.word').fadeOut(100, function () {
              $(document).find(".word").attr("style", "");
            })
          }

          let basketPopupSlider = $(document).find('[data-entity="popup-basket-calendar"]');
          if (basketPopupSlider.length) {
            basketPopupSlider.slick({
              infinite: true,
              dots: false,
              arrows: false,
              slidesToScroll: 3,
              autoplay: false,
              autoplaySpeed: 5000,
              autoplayHoverPause: true,
              fade: false,
              touchThreshold: 14,
              swipeToSlide: true,
              slidesToShow: 3,
              responsive: [{breakpoint: 640, settings: {slidesToScroll: 5, slidesToShow: 5}}],
            })

            if (
              datePopup !== undefined
              &&
              datePopup !== ''
            ) {
              if (wordCalOpen) {
                $(document).find(".word__cal").trigger('click');
              }
              if (basketPopupSlider.find('.month__slide[data-basket-popup-day="' + datePopup + '"]').length) {
                basketPopupSlider.find('.month__slide[data-basket-popup-day="' + datePopup + '"]').find('a').click();
              }
            }
          }
        }
      }
    });

    if (updateCalendar) {
      var date = '',
        $activeCalendarDate;

      $activeCalendarDate = $(document).find('.js-catalog-menu-day.day_active');

      if ($activeCalendarDate.length) {
        date = $activeCalendarDate.data('date');
      } else {
        $activeCalendarDate = $(document).find('.js-basket-menu-day.day_active');
        if ($activeCalendarDate.length) {
          date = $activeCalendarDate.data('date');
        }
      }

      if (
        datePopup !== undefined
        &&
        datePopup !== ''
      ) {
        $activeCalendarDate = $(document).find('.js-catalog-menu-day[data-date="' + datePopup + '"]');

        if ($activeCalendarDate.length) {
          date = $activeCalendarDate.data('date');
        }
      }
      if (date !== '') {
        $.ajax({
          method: 'GET',
          url: '/ajax/calendarDateList.php',
          data: {
            'date': date,
            'store-date': $activeCalendarDate.data('store-date'),
          },
          cache: false,
          success: function (data) {
            if (data) {
              $activeCalendarDate.find('.js-calendar-day-price').html(data);
            } else {
              $activeCalendarDate.find('.js-calendar-day-price').html('');
            }
          }
        });
        $.ajax({
          url: '/ajax/getCollOrderMembers.php',
          type: 'post',
          dataType: 'html',
          success: function(html) {
            $('.js-coll-order-members').html(html);
          }
        });
      }
    }
  }

  $(document).click(function (e) {
    var $currItem = $(e.target).closest(".cartbasket");
    if ($currItem.length !== 0) {
      $(document).find(".dropdownMenuBasketModal").toggleClass('show');
    }
  });

  jQuery(document).on('click', function (e) {
    var $el = jQuery(e.target).closest('.cartbasket , .dropdown-menu');
    if ($el.length) return;
    $(document).find(".dropdownMenuBasketModal").removeClass('show');
  });


  //Сократить текст блюда в корзине
  function textaddStep1(id) {
    var rollinfo = document.getElementById(id);
    var string = rollinfo.innerHTML;
    //49
    var shortstring = string.substring(45, string.length - 300) + "... <a class='roll__add'>см. полностью</a>";
    rollinfo.innerHTML = shortstring;

    rollinfo.onmouseout = function (e) {
      rollinfo.innerHTML = shortstring;
    };

    rollinfo.onmouseover = function (e) {
      rollinfo.innerHTML = string;
    };
  }

  window.textaddStep1 = textaddStep1;

  //Сократить текст блюда в корзине (завершение оформления заказа)
  window.textaddStep2 = function (id) {
    var rollinfo = document.getElementById(id);
    var string = rollinfo.innerHTML;
    //25
    var shortstring = string.substring(40, string.length - 300) + "... <a class='roll__add'>см. полностью</a>";
    rollinfo.innerHTML = shortstring;

    rollinfo.onmouseout = function (e) {
      rollinfo.innerHTML = shortstring;
    };

    rollinfo.onmouseover = function (e) {
      rollinfo.innerHTML = string;
    };
  }

  $(function () {
    /*
    function initScrollbar() {
      $("#gallery").css("overflow-x", "auto");

      if ($(window).width() > 375) {
        $("#gallery").mCustomScrollbar({
          axis: "x",
          theme: "light-3",
          advanced: {
            autoExpandHorizontalScroll: true,
            updateOnContentResize: true
          },
        });
      }
    }
    */

    function initCarousel() {
      $('.carousel').slick({
        dots: true,
        dotsClass: 'carousel-dots',
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        autoplay: true
      });
    }


    function initMenu(id_menu) {
      var menu = $('.' + id_menu);

      if (id_menu == 'main-menu') {
        menu.find('li a').click(function (e) {

          var li_current = $(this).parent();

          if (li_current.is('.active')) {
            li_current.removeClass('active');
            e.preventDefault();
            location.hash = '';
          } else {
            menu.find('li.active').removeClass('active');
            li_current.addClass('active');
          }
        });
      } else {
        menu.find('li a').click(function () {
          menu.find('li.active').removeClass('active');

          var li_current = $(this).parent();
          li_current.addClass('active');
        });
      }
    }

    //скролл текста на странице about_us
    /*$("#about-us").mCustomScrollbar({
      axis: "y",
      theme: "light-3",
      advanced: {},
    });*/

    // переключение саб меню под нужные категории
    $(document).on('click', '.main-menu .menu-item', function () {

      //для того чтобы не выводились подкатегории комбо
      if (!$(this).hasClass('hide_sub')) {
        if ($('.main-menu li.active').length > 0) {
          $('.main-menu-sub-block').addClass('show');
          var _this = $(this),
            menuData = _this.data('menuitem'),
            subMenuData = $('.main-menu-sub-block').find($('[data-menuitem=' + menuData + ']'));

          $('.main-menu-sub').removeClass('main-menu-sub--active');
          subMenuData.addClass('main-menu-sub--active');

          subMenuData.find($('.all a')).click();

          if ($('.main-menu li').hasClass('active')) {
            $('.main-menu-sub--active').addClass('yes-sub');
          } else {
            $('.main-menu-sub--active').removeClass('no-sub');
          }
        } else {
          $('.main-menu-sub--active').removeClass('main-menu-sub--active');

          var gallery = $('#gallery');
          var combo = $('#galleryCombo');

          var itemsCombo = combo.find('.item:not(.empty)');

          var items = gallery.find('.item:not(.empty)');

          gallery.fadeOut(500, function () {
            $.each(items, function (key, value) {
              $(this).css('display', 'inline-block');
            });
            gallery.fadeIn({
              duration: 500,
              start: function () {
                console.log("s2!!!");
                //$("#gallery").mCustomScrollbar("update");
              }
            });
          });

          $.each(itemsCombo, function (key, value) {
            $(this).css('display', 'inline-block');
          });
        }
      }

    });

    function initMenus() {
      initMenu('main-menu');
      initMainMenuSub();
    }

    function initMainMenuSub() {
      initMenu('main-menu-sub');

      var menu = $('#main-menu-sub');
      var gallery = $('#gallery');
      var combo = $('#galleryCombo');

      menu.find('li a').click(function () {
        console.log("!!!");

        var filter_id = $(this).attr('id');

        var itemsCombo = combo.find('.item');

        var items = gallery.find('.item');
        var item_class = '';
        var item_data = '';

        gallery.fadeOut(500, function () {
          $.each(items, function (key, value) {
            item_class = $(this).attr('class');
            if (item_class.indexOf('item-dish') > -1) {
              item_data = $(this).attr('data-item');

              if ((item_data == filter_id) || (filter_id == 'filter-all')) {
                $(this).css('display', 'inline-block');
              } else {
                $(this).css('display', 'none');

              }
            }
          });
          gallery.fadeIn({
            duration: 500,
            start: function () {
              console.log("!!!!!!");
              //$("#gallery").mCustomScrollbar("update");
            }
          });
        });

        $.each(itemsCombo, function (key, value) {
          item_class = $(this).attr('class');
          if ((item_class.indexOf('empty') == -1) && (item_class.indexOf('item-my') == -1) && (item_class.indexOf('item-adv') == -1)) {

            item_data = $(this).attr('data-item');

            if ((item_data == filter_id) || (filter_id == 'filter-all')) {
              $(this).css('display', 'inline-block');
            } else {
              $(this).css('display', 'none');
            }
          }
        });
      });

      initMainMenuSubWidth();
    }

    function initMainMenuSubWidth() {
      var menu = $('#main-menu');
      var menu_sub = $('#main-menu-sub');
      var menu_sub_block = $('#main-menu-sub-block');
      var window_w = $(window).width();

      var menu_w = parseInt(menu.width());
      var menu_sub_w = parseInt(menu_sub.width());

      if (window_w > 1024) {
        if (menu_w > menu_sub_w) {
          menu_sub_block.css('width', menu_w + 'px');
        }
      }
    }

    // ОТБРАЖЕНИЕ ПРОМОКОДА//////////////////////////
    $(document).on('click', '.form-control', function () {
      $('.promocode button').css('display', 'block');
      $('.form-control').css('display', 'block');
      $('.form-group-mask').css('display', 'none');
    });

    // МОДАЛКА КАРТОЧКИ ТОВАРОВ
    $(document).on('click', '.closeModalCard, .arrow', function () {
      $('.modalCardCont').css('display', 'none');
      $('body').css('overflow-y', 'auto');
      //$('.page-header').css('z-index', '3');
      $('.page-header, .modalCard').removeClass('modal-open1');
    });
    $(document).on('mousedown', '.modalCardCont', function (e) {
      // $('.modalCardCont').mousedown(function(e){
      if ($(e.target).attr('class') == 'modalCardCont') {
        $('.modalCardCont').css('display', 'none');
        $('body').css('overflow-y', 'auto');
        //$('.page-header').css('z-index', '3');
        $('.page-header, .modalCard').addClass('modal-open1');
      }
    });

    // СЛАЙДЕР КАРТОЧКИ ТОВАРОВ


    $(document).on('change input', '.js-number', function () {

      if (this.value.match(/[^0-9]/g)) {
        this.value = this.value.replace(/[^0-9]/g, '')
      }

      return false;

    });

    // ДОБАВИТЬ ПРИПРАВЫ
    $(document).on('click', '.imgContSlider', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });

    // ВВЕСТИ ПРОМОКОД В КОРЗИНЕ НА МОБИЛКЕ
    $(document).on('click', '.form-group-mask', function () {
      $('.form-group-mask').css('display', 'none');
      $('.form-group .form-control').css('display', 'block');
    });

    // РЕДАКТИРОВАНИЕ ПРОФИЛЯ - ИСТОРИЯ ЗАКАЗОВ(РАСКРЫТИЕ)
    var a = 0;
    $(document).on('click', '.histiryBlock-view', function () {
      if (a == 0) {
        $('.histiryBlock .leftBlock').css('height', 'auto');
        $('.histiryBlock .rightBlock').css('height', 'auto');
        $('.histiryBlock .histiryBlock-view').text('Свернуть');
        a = 1;
      } else {
        $('.histiryBlock .leftBlock').css('height', '294px');
        $('.histiryBlock .rightBlock').css('height', '294px');
        $('.histiryBlock .histiryBlock-view').text('Показать еще');
        a = 0;
      }
    });

    // КОМБО КОНСТРУКТОР////////////////////
    /*delete $(document).on('click', '.plusItem .addItemCombo', function () {
        var path = $(this).parent().parent();
        var summItem = +$(path).find('.sum__number').text();

        summItem = summItem+1;

        $(path).find('.sum__number').text(summItem);
        $(path).find('.amount__number').text(summItem);

        $(path).find('.amount').css('opacity', '1');
    });*/
    /*delete $(document).on('click', '.plusItem .minusItemCombo', function () {
        var path = $(this).parent().parent();
        var summItem = +$(path).find('.sum__number').text();

        switch (summItem) {
            case (2):
                $(path).find('.amount').css('opacity', '0');
                summItem = summItem - 1;

                $(path).find('.sum__number').text(summItem);
                $(path).find('.amount__number').text(summItem);
                break;

            case (1):
                $('#galleryCombo .gallery-inner').append(path);

                $(path).find('.amount').css('opacity', '0');

                $(path).draggable("enable");

                var items = 0;
                $('.comboMenu__items .item').each(function(i, el){
                    items = i+1;
                });
                if (items == 0) {
                    $('.comboMenu  .allPrice').css({ 'opacity': '0' });
                    $('.comboMenu__bckgnd-content').css({ 'opacity': '1' });
                }

                summItem = summItem - 1;
                break;

            default:
                summItem = summItem - 1;

                $(path).find('.sum__number').text(summItem);
                $(path).find('.amount__number').text(summItem);
        }


        var items = 0;
        $('.comboMenu__items .item').each(function (i, el) {
            items = i + 1;
        });
        if (items <= 8) {
            $('.comboMenu__items .item').removeClass('itemBasket');
            $('.comboMenu__items').removeClass('comboMenu__itemsBasket');
            // $('.comboMenu').css('top', '-4%');
            $('.comboMenu__bckgnd').css({'background': 'transparent'});
            $('.comboMenu__bckgnd img').css({ 'opacity': '1'});

            $('.comboMenu .comboMenu__items .mCSB_container').addClass('scrollContainer');
            // $('.comboMenu .comboMenu__items').css({ 'overflow-y': 'hidden' })
        }

        $('#galleryCombo .gallery-inner .item').removeClass('itemBasket');

    });*/
    /*delete $(document).on('click', '#galleryCombo .gallery-inner .item', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        }
        else {
            $(this).addClass('active');
        }
    });*/
    /*delete $(document).on('click', '.gallery-inner .item .icon-add', function (event) {

        var item = $(this).parent();
        $('.comboMenu .comboMenu__items .mCSB_container').append(item);
        $('.comboMenu .comboMenu__items .mCSB_container').addClass('scrollContainer');

        $('.comboMenu .comboMenu__items .item').each(function (i, el) {
            var index = 100000 - i;
            $(el).css({ 'z-index': index });
        });

        $(event.target).css({ 'opacity': '1', 'cursor': 'pointer' });

        $(this).parent().draggable("disable");

        $('.comboMenu  .allPrice').css({ 'opacity': '1' });
        $('.comboMenu__bckgnd-content').css({ 'opacity': '0' });

        let items = 0;
        $('.comboMenu__items .item').each(function (i, el) {
            items = i + 1;
        });

        if (items > 8) {
            $('.comboMenu__items .item').addClass('itemBasket');
            $('.comboMenu__items').addClass('comboMenu__itemsBasket');
            // $('.comboMenu').css('top', '-6.5%');

            $('.comboMenu__bckgnd').css({ 'background': '#fff' });
            $('.comboMenu__bckgnd img').css({ 'opacity': '0' });

            $('.comboMenu .comboMenu__items .mCSB_container').removeClass('scrollContainer');
        }

    });*/

    // $('.main-menu-sub--active').find('li.all').trigger('click');

    $("#form-autorization").validate({
      rules: {
        email: {
          email: true,
          required: true
        },
        password: {
          required: true,
          minlength: 6
        },
        password2: {
          required: true,
          minlength: 6,
          equalTo: "#password"
        }
      },
      messages: {
        email: {
          required: "Это поле обязательно для заполнения",
          email: "Неверный формат электронной почты"
        },
        password: {
          required: "Это поле обязательно для заполнения",
          minlength: "Пароль должен быть минимум 6 символов"
        },
        password2: {
          required: "Подтвердите пароль",
          minlength: "Ваш пароль должен содержать не меньше 6 символов",
          equalTo: "Пароли не совпадают"
        }
      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success');
        $(element).closest('.form-group').addClass('has-error');
        setTimeout(function () {
          var textError = $(element).closest('.form-group').find('.error').text();
          $(element).closest('.form-group').find('.error-message').text(textError);
        }, 100);

      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error');
      },
      errorElement: 'div',
    });

    $(".dropdown-menu li a").click(function () {
      var selText = $(this).html();
      $(this).parents('.form-group-select').find('.form-control-static').html(selText);
    });

    $(document).on('change input', '.js-number', function () {
      if (this.value.match(/[^0-9]/g)) {
        this.value = this.value.replace(/[^0-9]/g, '')
      }

      return false;
    });

    // изменение количества персон в оформлении заказа
    $('.count').prop('disabled', true);
    $(document).on('click', '#btn-plus', function () {
      $('.count').val(parseInt($('.count').val()) + 1);
    });
    $(document).on('click', '#btn-minus', function () {
      $('.count').val(parseInt($('.count').val()) - 1);
      if ($('.count').val() == 0) {
        $('.count').val(1);
      }
    });

    setTimeout(function () {

      var hashPage = 'subCateg_' + window.location.hash.replace('#', '');  //#combo
      var itemMenu = $('.main-menu li');
      var linkMenu = $('.main-menu li a');
      var dataAttrMenuLink = linkMenu.data('menuitem'); //subCateg_combo

      $('.main-menu li a').each(function (linkMenu) {

        var item = $(this).data('menuitem');

        if (item == hashPage) {
          $(this).trigger('click');
        }
        /*
                    else {
                        $(this).parent('li').removeClass('active');
                    }*/
      });

    }, 100);

    // Добавление количества из спана в инпут
    $(".ui-draggable-disabled").each(function (index) {

      var $this = $(this)

      var comboDragItemAmount = $this.find('.sum__number').text();

      var comboDragItemInput = $this.find('.plusItemInput').val(comboDragItemAmount);

      console.log(comboDragItemInput)

    });

    //табы в оформлении
    $(".form-order .btn-to-step2").click(function () {
      $('.order-steps li').removeClass('active');
      $('.order-steps li:nth-child(2)').addClass('active');
    })

    // МОДАЛКА КАРТОЧКИ ТОВАРОВ
    $(document).on('click', '.closeModalCard, .arrow', function () {
      $('.modalCardCont').css('display', 'none');
      $('body').css({'overflow-y': 'auto', 'position': 'unset'});
      //$('.page-header').css('z-index', '3');
      $('.page-header, .modalCard').removeClass('modal-open');
      $('.menu-user').removeClass('menu_fixed');
    });
    $(document).on('mousedown', '.modalCardCont', function (e) {
      // $('.modalCardCont').mousedown(function(e){
      if ($(e.target).attr('class') == 'modalCardCont') {
        $('.modalCardCont').css('display', 'none');
        $('body').css({'overflow-y': 'auto', 'position': 'unset'});
        // $('.page-header').css('z-index', '3');
        $('.page-header, .modalCard').addClass('modal-open');
      }
    });

    $("#swipe").swipe({
      swipeUp: function (event, direction, distance, duration, fingerCount) {
        $('.modalCardCont').addClass('closeClass');
        $('body').css({'overflow-y': 'auto', 'position': 'unset'});
        $('.page-header, .modalCard').removeClass('modal-open');
        $('.menu-user').removeClass('menu_fixed');
      },
      swipeDown: function (event, direction, distance, duration, fingerCount) {
        $('.modalCardCont').addClass('closeClass');
        $('body').css({'overflow-y': 'auto', 'position': 'unset'});
        $('.page-header, .modalCard').removeClass('modal-open');
        $('.menu-user').removeClass('menu_fixed');
      },
      threshold: 100
    });

    /*
    $(window).on("load resize", function () {
      if ($(".content-page-scroll").length > 0 && ($(".combo").length < 1)) {
        var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (winWidth >= 900) {
          $(".content-page-scroll .content").mCustomScrollbar({
            axis: "y",
            theme: "light-3"
          });
        } else {
          $('.content-page-scroll .content').mCustomScrollbar("destroy");
        }
      }
    });
    */


    $.validator.addMethod('phonecustom', function (value, element) {
      return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/);
    }, 'Введите корректный телефон');

    $.validator.addClassRules('js-phone', {
      phonecustom: true
    });

    window.addEventListener('load', function () {
      $(document).find(".month").removeClass("loading");
      // $(".menu_mob_container").removeClass("loading");

      if ($(document).find(".camp_combo").length) {
        $(document).find(".menu_mob_container").addClass("dual_mob_container");
      }
    });

    $("input[type=number]").keypress(function (event) {
      event = event || window.event;
      if (event.charCode && event.charCode != 0 && event.charCode != 46 && (event.charCode < 48 || event.charCode > 57))
        return false;
    });

    $.validator.addMethod('myPhone', function (value, element) {
      if (value == '+7 (___) ___-____' || value == '') {
        return true;
      } else {
        return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/);
      }

    }, 'Введите корректный телефон');

    $.validator.addMethod('bDay', function (value, element) {
      if (value == '__.__.____' || value == '') {
        value = '';
        return true;
      } else {
        return value.match(/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/);
      }

    }, 'Введите корректную дату');

    // Фиксировать виды блюд при прокрутке мобильная
    var height;

    function isOnScreen(elem) {
      if (elem.length == 0) {
        return;
      }
      var $window = jQuery(window);
      var viewport_top = $window.scrollTop();
      var viewport_height = $window.height();
      var viewport_bottom = viewport_top + viewport_height;
      var $elem = jQuery(elem);
      var top = $elem.offset().top;
      var bottom = top + height;

      height = $elem.height();

      return (viewport_bottom - viewport_height <= top)
    }

    var navmob = $('.menu-nav_mob');
    var navmobc = $('.menu_mob_container');
    window.addEventListener('scroll', function (e) {
      if (isOnScreen(jQuery('.menu_mob_container'))) {
        navmob.removeClass("menu-nav_fix");
        navmobc.css("height", "");
      } else {
        navmob.addClass("menu-nav_fix");
        navmobc.css("height", height);
      }
    });

    var navpk = $('.menu-nav_pk');
    var navpkc = $('.menu_pk_container');
    window.addEventListener('scroll', function (e) {
      if (isOnScreen(jQuery('.menu_pk_container'))) {
        navpk.removeClass("menu-nav_fix");
        navpkc.css("height", "");
      } else {
        navpk.addClass("menu-nav_fix");
        navpkc.css("height", height);
      }
    });

    //initScrollbar();
    initNavbar();
    initCarousel();
    initMenus();

  })
})(jQuery);

window.initNavbar = initNavbar;
